var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconLoveItCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.247 17.25a6 6 0 1 1-6-6",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.247 12.75-5.469 5.469a.75.75 0 0 1-1.061 0L15 16.5m-6.777 0-5.811-6.065a5.673 5.673 0 0 1-1.063-6.549h0a5.672 5.672 0 0 1 9.085-1.473L12 3.978l1.566-1.565a5.672 5.672 0 0 1 9.085 1.473h0A5.678 5.678 0 0 1 22.632 9",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconLoveItCheck);
export default __webpack_public_path__ + "static/media/streamline-icon-love-it-check.37ffd66d.svg";
export { ForwardRef as ReactComponent };